export default __webpack_public_path__ + "static/media/xbox_controller.c579567e.png";